import $ from 'jquery';
import AOS from 'aos';

$(window).on('load', function () {
  AOS.refresh();
});

$(function () {
  AOS.init({
    once: true
  });
});